import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FileDownloadRequestBody, FileDownloadResponse } from "./types";

export class FileDownloadAPI extends BaseAPI<
  FileDownloadRequestBody,
  FileDownloadResponse
> {
  protected route = ApiRoutes.file.download;
  protected method = RequestMethod.POST;
}
